// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"121":"bd965c89","281":"e50c0280"}[chunkId] + ".js";
};